import keyboardJS from 'keyboardjs';
import { breakpoints } from '../../../tokens/js/utils/vars/media';

const openMenu = (menuItem) => {
  menuItem?.setAttribute('aria-expanded', 'true');
};

const closeMenu = (menuItem) => {
  menuItem?.setAttribute('aria-expanded', 'false');
};

const closeMenuOnFocusOtherItem = (item) => {
  if (item.getAttribute('aria-expanded') !== 'true') {
    const openSibling = item.parentNode.querySelector('[aria-expanded="true"]');

    closeMenu(openSibling);
  }
};

const closestOpenMenu = () =>
  document.activeElement.closest('.menu__item[aria-expanded="true"]');

const currentlyOpenMenus = () =>
  document.querySelectorAll('.menu [aria-expanded="true"]');

const menus = document.querySelectorAll('.menu');

const getAncestor = (element, selector) => {
  let el = element;

  while (
    // eslint-disable-next-line no-cond-assign
    (el = el?.parentElement) &&
    !(el.matches || el.matchesSelector).call(el, selector)
  );

  return el;
};

const closeOpenedMenus = () => {
  const openedMenus = document.body.querySelectorAll(
    '.menu__item[aria-expanded="true"]'
  );

  openedMenus.forEach((item) => {
    closeMenu(item);
  });
};

document.body.addEventListener('touchstart', (e) => {
  const menu = getAncestor(e.target, '.menu');

  if (!menu) {
    closeOpenedMenus();
  }
});

const requiresOpening = (menuItem) => {
  if (!menuItem) {
    return false;
  }

  if (window.innerWidth <= breakpoints.tablet) {
    return false;
  }

  return menuItem.getAttribute('aria-expanded') === 'false';
};

menus?.forEach((menu) => {
  const menuItemsWithSubmenu = menu.querySelectorAll(
    '.menu__item[aria-haspopup="true"]'
  );
  menuItemsWithSubmenu.forEach((itemWithMenu) => {
    const itemSiblings = itemWithMenu.parentNode.querySelectorAll(
      ':scope > .menu__item'
    );

    itemSiblings.forEach((menuItem) => {
      // accessible events
      menuItem.addEventListener('focusin', () => {
        closeMenuOnFocusOtherItem(menuItem);
      });
    });

    // pointer level events
    itemWithMenu.addEventListener('mouseenter', (e) => {
      openMenu(e.target);
    });
    itemWithMenu.addEventListener('mouseleave', (e) => {
      closeMenu(e.target);
    });

    itemWithMenu.addEventListener('touchstart', (e) => {
      const menuItem = e.currentTarget;

      if (requiresOpening(menuItem) === false) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (
        menuItem.getAttribute('aria-haspopup') !== 'true' ||
        (menuItem.parentElement?.classList.contains('menu') &&
          menuItem.parentElement.getAttribute('data-level') === '0')
      ) {
        closeOpenedMenus();
      }

      openMenu(menuItem);
    });
  });
});

// keyboard events
menus.length &&
  keyboardJS.bind('esc', () => {
    const parentLink = closestOpenMenu().querySelector(':scope > .menu__link');

    closeMenu(closestOpenMenu());
    parentLink.focus();
  });

menus.length &&
  keyboardJS.bind('enter', (e) => {
    const isFocused = e.target === document.activeElement;
    if (
      document.activeElement.parentNode.getAttribute('aria-expanded') === 'true'
    ) {
      closeMenu(closestOpenMenu());
    } else {
      isFocused && openMenu(e.target.parentNode);
    }
  });

const parentMenus = document.querySelectorAll('.menu[data-level="0"]');

parentMenus.forEach((menu) => {
  menu.addEventListener('focusout', () => {
    setTimeout(() => {
      if (!menu.contains(document.activeElement)) {
        currentlyOpenMenus().forEach((open) => {
          closeMenu(open);
        });
      }
    }, 0);
  });
});
